import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { StyledModal,CalendarHeader,Border,Grid,Card,Header,Title,Badge,PointsList,Description, ButtonContainer, TierBody, LevelIconContainer } from './styles';
import { AdminCloseIcon, RewardsChallengeIcon } from '../../../utils/icons';
import { Modal } from 'react-bootstrap';
import { CommonButtonPopup } from '../../ReportsV2/styles';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GetCompanyAdminRewardTierConfig } from '../../../redux/constants/apiConstants';
import { fetchApi } from '../../../utils/methods';
import SkeletonLoder from '../../common/skeletonLoder';
import LazyImage from '../../common/LazyImage/LazyImage';
import { ImageUrl } from '../../../utils/constants';

const TIER_CONFIG = [
  {
    id: 'recommended',
    title: 'Recommended',
    badge: 'Standard',
    description: 'Balanced progression that works for most teams.',
    buttonText: 'Use Recommended',
    headingBg:'linear-gradient(90deg, rgba(231, 238, 248, 0.60) 0%,rgba(185, 200, 232, 0.60) 100%)',
    tierBg:'#8391D1'
  },
  {
    id: 'boost',
    title: 'Boost Engagement',
    badge: 'Accelerated',
    description: 'Faster rewards to drive participation and momentum.',
    buttonText: 'Use Boost Engagement',
    headingBg:'linear-gradient(90deg, rgba(238, 220, 230, 0.60) 0%,rgba(206, 152, 179, 0.60) 100%)',
    tierBg:'#A65C7C'
  },
  {
    id: 'custom',
    title: 'Build Your Own',
    badge: 'Custom',
    description: 'Set your own point goals and thresholds.',
    buttonText: 'Set Custom Levels',
    headingBg:'linear-gradient(90deg, rgba(218, 218, 174, 0.60) 0%,rgba(197, 195, 127, 0.60) 100%)',
    tierBg:'#A49A4E'
  }
];

// const TIER_POINTS = {
//   recommended: {
//     Bronze: 2000,
//     Silver: 4000,
//     Gold: 6000,
//     Platinum: 8000
//   },
//   boost: {
//     Bronze: 2500,
//     Silver: 5000,
//     Gold: 7500,
//     Platinum: 10000
//   },
//   custom: null
// };

export const TIER_ICONS = {
  Bronze: { icon: RewardsChallengeIcon, color: '#CD7F32',bg:'#FCF2F3',border:'#DA6C74',src:'/images/Rewards/new-bronze.png' },
  Silver: { icon: RewardsChallengeIcon, color: '#C0C0C0',bg:'#EFEFEF',border:'#DCDCDC',src:'/images/Rewards/new-silver.png' },
  Gold: { icon: RewardsChallengeIcon, color: '#FFD700',bg:'#EFEFEF',border:'#DCDCDC',src:'/images/Rewards/new-gold.png' },
  Platinum: { icon: RewardsChallengeIcon, color: '#6B5B95',bg:'#EFEFEF',border:'#DCDCDC',src:'/images/Rewards/new-platinum.png' }
};

const TiersModal = ({
  show,
  icon,
  title,
  onCancel,
  modalWidth = "400px",
  modalHeight,
  onClose,
  history,
  tierConfig,
  companyInfo,
  onTierSelect
}) =>{

  const[tierConfigDetails, setTierConfigDetails] = useState();
  const[selectedTierId, setSelectedTierId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    fetchCompanyCompanyTierConfigDetails();
  },[])


  const fetchCompanyCompanyTierConfigDetails = async() =>{
    setLoading(true);
    const tierConfigType = tierConfig === 'new' ? 0 : 1
    try {
      const companyRewardsData = await fetchApi(GetCompanyAdminRewardTierConfig+'?company_id='+ companyInfo.id +  `&future=${tierConfigType}` , "GET");
      if(companyRewardsData.status === 'success'){
        setTierConfigDetails(companyRewardsData.data);
      }else{
        toast.error(companyRewardsData.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      setLoading(false);
    }
  }

  const onLevelSelect = (tier,points)=>{

    setSelectedTierId(tier?.id)

    if(tier?.id === 'custom'){
      history.push({pathname:"/company/rewards/manage-tiers",state:{tierConfig:tierConfig}})
    }else{
      onTierSelect(tier,points,tierConfigDetails);
    }
  }

  const SelectPointTierLevels = () => {
    window.console.log("hihi")
    
    return (
      <Grid>
        {TIER_CONFIG.map((tier) => {
          const isActive = tier.id === selectedTierId;
          const points = tierConfigDetails?.tier_levels?.[tier.id];
    
          return (
            <Card key={tier.id} active={isActive}>
              <Header bg={tier?.headingBg}>
                <Title>{tier.title}</Title>
               
              </Header>
              <TierBody>
                <Badge bg={tier?.tierBg}>{tier.id === tierConfigDetails?.last_year_level ? 'Last Year Points' : tier.badge}</Badge>
      
                <Description>{tier.description}</Description>
      
                {points && (
                  <PointsList>
                    {Object.entries(points).map(([level, value]) => {
                      const LevelIconDetails = TIER_ICONS[level];
      
                      return (
                        <li key={level}>
                          <LevelIconContainer bg={LevelIconDetails?.bg} border={LevelIconDetails?.border}>
                            <LazyImage div={'image'} src={ImageUrl + LevelIconDetails.src}/>
                          </LevelIconContainer>
                          <span>
                            <span className='level'>{level}</span> – {value.toLocaleString()} Points
                          </span>
                        </li>
                      );
                    })}
                  </PointsList>
                )}

              </TierBody>

              <ButtonContainer>
                <CommonButtonPopup
                  active={isActive}
                  onClick={() => {onLevelSelect(tier,points);}}
                >
                  {isActive ? 'Selected' : tier.buttonText}
                </CommonButtonPopup>
              </ButtonContainer>
            </Card>
          );
        })}
      </Grid>
    );
  };
      
    
    
  return(
    <>
      <StyledModal show={show} width={modalWidth} height={modalHeight}>
        <div className="modal-content-padding">
          <CalendarHeader>
            <div className="left-content">
              <div className="icon">{icon && icon}</div>
              <div>{title}</div>
            </div>
            <div className="close-icon" onClick={()=>onClose ? onClose() :onCancel()}>
              {AdminCloseIcon()}
            </div>
          </CalendarHeader>
          <Border/>
    
        </div>
  
        <div className='modal-body'>
  
          {loading ?
            <Grid>
              {Array.from({ length: 3 }).map((_, index) => (
                <SkeletonLoder
                  key={index}
                  width="285px"
                  height="387px"
                  style={{ gap: "25px" }}
                />
              ))}
            </Grid> : SelectPointTierLevels()}
        </div>
    
        <Modal.Footer style={{borderTop:'none',display:'flex',paddingTop:'0px',justifyContent:'center'}}>
    
    
        </Modal.Footer>
      </StyledModal>
    </>
  )};


TiersModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title:PropTypes.string, 
  onCancel: PropTypes.func.isRequired,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  icon: PropTypes.node.isRequired, 
  onClose:PropTypes.func,
  history:PropTypes.object,
  tierConfig:PropTypes.string,
  companyInfo:PropTypes.object,
  onTierSelect:PropTypes.func
};

export default withRouter((TiersModal));
  
